import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Header from "./../components/Header";
import ShopSection from "./../components/homeComponents/ShopSection";
import FeaturedProductsCarousel from "../components/homeComponents/FeaturedProductsCarousel";
import Footer from "./../components/Footer";
import HeroCarousel from "../components/homeComponents/HeroCarrusel";
import CategoriesSection from "../components/homeComponents/CategoriesSection";
import TrustBar from "../components/homeComponents/TrustBar";
import { listStoreBanners } from "../Redux/Actions/BannerActions";
import InstagramVideosCarousel from "../components/homeComponents/InstagramVideosCarousel";
import InstagramPhotosCarousel from "../components/homeComponents/InstagramPhotosCarousel";

const HomeScreen = ({ match, location }) => {
  const dispatch = useDispatch();

  const keyword = match?.params?.keyword || "";
  const pageNumber =
    match?.params?.pageNumber || match?.params?.pagenumber || "";

  const isSearchMode = Boolean(keyword.trim());
  const isFeaturedMode =
    location.pathname === "/destacados" ||
    location.pathname.startsWith("/destacados/");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [keyword, pageNumber, location.pathname]);

  useEffect(() => {
    if (!isSearchMode && !isFeaturedMode) {
      dispatch(listStoreBanners());
    }
  }, [dispatch, isSearchMode, isFeaturedMode]);

  return (
    <div>
      <Header hideCategoriesBar={false} />

      {isSearchMode ? (
        <ShopSection
          keyword={keyword}
          pagenumber={pageNumber}
          isSearchMode={true}
        />
      ) : isFeaturedMode ? (
        <ShopSection
          pagenumber={pageNumber}
          isFeaturedMode={true}
        />
      ) : (
        <>
          <InstagramVideosCarousel />
          <ShopSection
            keyword={keyword}
            pagenumber={pageNumber}
            isSearchMode={false}
          />
          <InstagramPhotosCarousel />
          <HeroCarousel />
          <FeaturedProductsCarousel />
          <CategoriesSection
            title="Nuestras categorías"
            withPagination={false}
            limitWithoutPagination={10}
          />
          {/* <CalltoActionSection /> */}
          <TrustBar />
        </>
      )}

      <Footer />
    </div>
  );
};

export default HomeScreen;